import type { MapControls, PerspectiveCamera } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import type { ElementRef, MutableRefObject } from "react";

import type { CameraTargetBounds } from "./camera.types.js";
import { clampOrbitControlsTarget } from "./camera.utils.js";

interface OfficeCameraControlsGuardProps {
  cameraRef: MutableRefObject<ElementRef<typeof PerspectiveCamera> | null>;
  orbitControlsRef: MutableRefObject<ElementRef<typeof MapControls> | null>;
  effectiveTargetBounds: CameraTargetBounds;
}

export const OfficeCameraControlsGuard = ({
  cameraRef,
  orbitControlsRef,
  effectiveTargetBounds,
}: OfficeCameraControlsGuardProps) => {
  useFrame(() => {
    if (!(cameraRef.current && orbitControlsRef.current)) {
      return;
    }

    clampOrbitControlsTarget({
      camera: cameraRef.current,
      controls: orbitControlsRef.current,
      targetBounds: effectiveTargetBounds,
    });
  });

  return null;
};
